export default __webpack_public_path__ + "static/media/screenshot1.335b2acd.jpg";